export default __webpack_public_path__ + "../ckeditor/plugins/table/dialogs/table.js";